import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-submitted-orders-modal',
	templateUrl: './submitted-orders-modal.html'
})

export class SubmittedOrdersModalComponent implements OnInit {
	allOrderIds = '';
	failedOrders: any[] = [];
	successfulOrders: any[] = [];
	startDate: string;
	endDate: string;

	constructor(public dialogRef: MatDialogRef<SubmittedOrdersModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any) {
	}

	closeModal() {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.successfulOrders = this.data.successfulOrders;
		this.failedOrders = this.data.failedOrders;

		for (let i = 0; i < this.successfulOrders.length; i++) {
			if (this.allOrderIds.length > 0) {
				this.allOrderIds += ',';
			}
			this.allOrderIds += `${this.successfulOrders[i].id}`;
		}

		this.startDate = this.successfulOrders.sort((a, b) => a.readyTimeFrom < b.readyTimeFrom ? -1 : 1)[0].readyTimeFrom;
		this.endDate = this.successfulOrders.sort((a, b) => a.readyTimeFrom > b.readyTimeFrom ? -1 : 1)[0].readyTimeFrom;
	}
}
